// source: pushwoosh/presets/presets.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var pushwoosh_channels_messagingApi_v2_payload_pb = require('../../pushwoosh/channels/messagingApi/v2/payload_pb.js');
goog.object.extend(proto, pushwoosh_channels_messagingApi_v2_payload_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.CreatePresetRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.CreatePresetResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.DeletePresetRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.DeletePresetResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.GetPresetRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.GetPresetResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.ListPresetsRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderBy', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderDirection', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.ListPresetsResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.Preset', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.ListPresetsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.displayName = 'proto.pushwoosh.rpc_v2.presets.ListPresetsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.Preset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.presets.Preset.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.Preset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.Preset.displayName = 'proto.pushwoosh.rpc_v2.presets.Preset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.ListPresetsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.displayName = 'proto.pushwoosh.rpc_v2.presets.ListPresetsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.GetPresetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.GetPresetRequest.displayName = 'proto.pushwoosh.rpc_v2.presets.GetPresetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.GetPresetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.GetPresetResponse.displayName = 'proto.pushwoosh.rpc_v2.presets.GetPresetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.CreatePresetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.displayName = 'proto.pushwoosh.rpc_v2.presets.CreatePresetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.CreatePresetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.displayName = 'proto.pushwoosh.rpc_v2.presets.CreatePresetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.displayName = 'proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.displayName = 'proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.DeletePresetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.displayName = 'proto.pushwoosh.rpc_v2.presets.DeletePresetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.presets.DeletePresetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.displayName = 'proto.pushwoosh.rpc_v2.presets.DeletePresetResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderDirection: jspb.Message.getFieldWithDefault(msg, 3, 0),
    page: jspb.Message.getFieldWithDefault(msg, 4, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 5, 0),
    searchByName: (f = msg.getSearchByName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    searchByCategoryList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.ListPresetsRequest;
  return proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 2:
      var value = /** @type {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderBy} */ (reader.readEnum());
      msg.setOrderBy(value);
      break;
    case 3:
      var value = /** @type {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderDirection} */ (reader.readEnum());
      msg.setOrderDirection(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearchByName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addSearchByCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderBy();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOrderDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSearchByName();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSearchByCategoryList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderBy = {
  NAME: 0,
  CREATED: 1,
  UPDATED: 2
};

/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderDirection = {
  ASC: 0,
  DESC: 1
};

/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OrderBy order_by = 2;
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderBy}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.getOrderBy = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderBy} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderBy} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional OrderDirection order_direction = 3;
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderDirection}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.getOrderDirection = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderDirection} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.OrderDirection} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.setOrderDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 page = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 per_page = 5;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue search_by_name = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.getSearchByName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
*/
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.setSearchByName = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.clearSearchByName = function() {
  return this.setSearchByName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.hasSearchByName = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated string search_by_category = 7;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.getSearchByCategoryList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.setSearchByCategoryList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.addSearchByCategory = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsRequest.prototype.clearSearchByCategoryList = function() {
  return this.setSearchByCategoryList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.presets.Preset.repeatedFields_ = [19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.Preset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.Preset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.Preset.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    platformsMap: (f = msg.getPlatformsMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedPropertiesMap: (f = msg.getLocalizedPropertiesMap()) ? f.toObject(includeInstance, proto.pushwoosh.channels.messagingApi.v2.Content.toObject) : [],
    localizedTitleMap: (f = msg.getLocalizedTitleMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedSubtitleMap: (f = msg.getLocalizedSubtitleMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedContentMap: (f = msg.getLocalizedContentMap()) ? f.toObject(includeInstance, undefined) : [],
    deeplink: jspb.Message.getFieldWithDefault(msg, 9, ""),
    deeplinkParamsMap: (f = msg.getDeeplinkParamsMap()) ? f.toObject(includeInstance, undefined) : [],
    richmedia: jspb.Message.getFieldWithDefault(msg, 11, ""),
    system: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    url: jspb.Message.getFieldWithDefault(msg, 13, ""),
    inboxImage: jspb.Message.getFieldWithDefault(msg, 14, ""),
    inboxIcon: jspb.Message.getFieldWithDefault(msg, 15, ""),
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    customData: (f = msg.getCustomData()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    isV2: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    banner: jspb.Message.getFieldWithDefault(msg, 21, ""),
    icon: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset}
 */
proto.pushwoosh.rpc_v2.presets.Preset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.Preset;
  return proto.pushwoosh.rpc_v2.presets.Preset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.Preset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset}
 */
proto.pushwoosh.rpc_v2.presets.Preset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 4:
      var value = msg.getPlatformsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readBool, null, 0, false);
         });
      break;
    case 5:
      var value = msg.getLocalizedPropertiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.channels.messagingApi.v2.Content.deserializeBinaryFromReader, "", new proto.pushwoosh.channels.messagingApi.v2.Content());
         });
      break;
    case 6:
      var value = msg.getLocalizedTitleMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = msg.getLocalizedSubtitleMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = msg.getLocalizedContentMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeeplink(value);
      break;
    case 10:
      var value = msg.getDeeplinkParamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setRichmedia(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSystem(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setInboxImage(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setInboxIcon(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    case 18:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setCustomData(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsV2(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setBanner(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.Preset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.Preset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.Preset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlatformsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeBool);
  }
  f = message.getLocalizedPropertiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.channels.messagingApi.v2.Content.serializeBinaryToWriter);
  }
  f = message.getLocalizedTitleMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLocalizedSubtitleMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLocalizedContentMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getDeeplink();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDeeplinkParamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRichmedia();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSystem();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getInboxImage();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getInboxIcon();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCustomData();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getIsV2();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getBanner();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<uint32, bool> platforms = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,boolean>}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getPlatformsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,boolean>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearPlatformsMap = function() {
  this.getPlatformsMap().clear();
  return this;};


/**
 * map<string, pushwoosh.channels.messagingApi.v2.Content> localized_properties = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.pushwoosh.channels.messagingApi.v2.Content>}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getLocalizedPropertiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.pushwoosh.channels.messagingApi.v2.Content>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.pushwoosh.channels.messagingApi.v2.Content));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearLocalizedPropertiesMap = function() {
  this.getLocalizedPropertiesMap().clear();
  return this;};


/**
 * map<string, string> localized_title = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getLocalizedTitleMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearLocalizedTitleMap = function() {
  this.getLocalizedTitleMap().clear();
  return this;};


/**
 * map<string, string> localized_subtitle = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getLocalizedSubtitleMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearLocalizedSubtitleMap = function() {
  this.getLocalizedSubtitleMap().clear();
  return this;};


/**
 * map<string, string> localized_content = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getLocalizedContentMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearLocalizedContentMap = function() {
  this.getLocalizedContentMap().clear();
  return this;};


/**
 * optional string deeplink = 9;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getDeeplink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setDeeplink = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * map<string, string> deeplink_params = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getDeeplinkParamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearDeeplinkParamsMap = function() {
  this.getDeeplinkParamsMap().clear();
  return this;};


/**
 * optional string richmedia = 11;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getRichmedia = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setRichmedia = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool system = 12;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getSystem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setSystem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string url = 13;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string inbox_image = 14;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getInboxImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setInboxImage = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string inbox_icon = 15;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getInboxIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setInboxIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated string categories = 19;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional google.protobuf.Timestamp created = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
*/
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp updated = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
*/
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Struct custom_data = 18;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getCustomData = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 18));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
*/
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setCustomData = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.clearCustomData = function() {
  return this.setCustomData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.hasCustomData = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool is_v2 = 20;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getIsV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setIsV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional string banner = 21;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getBanner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setBanner = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string icon = 22;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset} returns this
 */
proto.pushwoosh.rpc_v2.presets.Preset.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    presetsList: jspb.Message.toObjectList(msg.getPresetsList(),
    proto.pushwoosh.rpc_v2.presets.Preset.toObject, includeInstance),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 3, 0),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.ListPresetsResponse;
  return proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.presets.Preset;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.presets.Preset.deserializeBinaryFromReader);
      msg.addPresets(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPresetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.presets.Preset.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated Preset presets = 1;
 * @return {!Array<!proto.pushwoosh.rpc_v2.presets.Preset>}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.getPresetsList = function() {
  return /** @type{!Array<!proto.pushwoosh.rpc_v2.presets.Preset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.rpc_v2.presets.Preset, 1));
};


/**
 * @param {!Array<!proto.pushwoosh.rpc_v2.presets.Preset>} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse} returns this
*/
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.setPresetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pushwoosh.rpc_v2.presets.Preset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.presets.Preset}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.addPresets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pushwoosh.rpc_v2.presets.Preset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.clearPresetsList = function() {
  return this.setPresetsList([]);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 per_page = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.presets.ListPresetsResponse} returns this
 */
proto.pushwoosh.rpc_v2.presets.ListPresetsResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.GetPresetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.GetPresetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.GetPresetRequest}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.GetPresetRequest;
  return proto.pushwoosh.rpc_v2.presets.GetPresetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.GetPresetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.GetPresetRequest}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.GetPresetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.GetPresetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.GetPresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.GetPresetRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.GetPresetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.GetPresetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    preset: (f = msg.getPreset()) && proto.pushwoosh.rpc_v2.presets.Preset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.GetPresetResponse}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.GetPresetResponse;
  return proto.pushwoosh.rpc_v2.presets.GetPresetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.GetPresetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.GetPresetResponse}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.presets.Preset;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.presets.Preset.deserializeBinaryFromReader);
      msg.setPreset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.GetPresetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.GetPresetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.presets.Preset.serializeBinaryToWriter
    );
  }
};


/**
 * optional Preset preset = 1;
 * @return {?proto.pushwoosh.rpc_v2.presets.Preset}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.prototype.getPreset = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.presets.Preset} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.presets.Preset, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.presets.Preset|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.GetPresetResponse} returns this
*/
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.prototype.setPreset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.GetPresetResponse} returns this
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.prototype.clearPreset = function() {
  return this.setPreset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.GetPresetResponse.prototype.hasPreset = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sendType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    platformsMap: (f = msg.getPlatformsMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedPropertiesMap: (f = msg.getLocalizedPropertiesMap()) ? f.toObject(includeInstance, proto.pushwoosh.channels.messagingApi.v2.Content.toObject) : [],
    localizedTitleMap: (f = msg.getLocalizedTitleMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedSubtitleMap: (f = msg.getLocalizedSubtitleMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedContentMap: (f = msg.getLocalizedContentMap()) ? f.toObject(includeInstance, undefined) : [],
    deeplink: (f = msg.getDeeplink()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    deeplinkParamsMap: (f = msg.getDeeplinkParamsMap()) ? f.toObject(includeInstance, undefined) : [],
    richmedia: (f = msg.getRichmedia()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    system: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    url: jspb.Message.getFieldWithDefault(msg, 13, ""),
    inboxImage: jspb.Message.getFieldWithDefault(msg, 14, ""),
    inboxIcon: jspb.Message.getFieldWithDefault(msg, 15, ""),
    customData: (f = msg.getCustomData()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    banner: jspb.Message.getFieldWithDefault(msg, 18, ""),
    icon: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.CreatePresetRequest;
  return proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSendType(value);
      break;
    case 4:
      var value = msg.getPlatformsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readBool, null, 0, false);
         });
      break;
    case 5:
      var value = msg.getLocalizedPropertiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.channels.messagingApi.v2.Content.deserializeBinaryFromReader, "", new proto.pushwoosh.channels.messagingApi.v2.Content());
         });
      break;
    case 6:
      var value = msg.getLocalizedTitleMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = msg.getLocalizedSubtitleMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = msg.getLocalizedContentMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDeeplink(value);
      break;
    case 10:
      var value = msg.getDeeplinkParamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRichmedia(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSystem(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setInboxImage(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setInboxIcon(value);
      break;
    case 16:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setCustomData(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setBanner(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSendType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatformsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeBool);
  }
  f = message.getLocalizedPropertiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.channels.messagingApi.v2.Content.serializeBinaryToWriter);
  }
  f = message.getLocalizedTitleMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLocalizedSubtitleMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLocalizedContentMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getDeeplink();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDeeplinkParamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRichmedia();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSystem();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getInboxImage();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getInboxIcon();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCustomData();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = message.getBanner();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string send_type = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getSendType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setSendType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<uint32, bool> platforms = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,boolean>}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getPlatformsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,boolean>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearPlatformsMap = function() {
  this.getPlatformsMap().clear();
  return this;};


/**
 * map<string, pushwoosh.channels.messagingApi.v2.Content> localized_properties = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.pushwoosh.channels.messagingApi.v2.Content>}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getLocalizedPropertiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.pushwoosh.channels.messagingApi.v2.Content>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.pushwoosh.channels.messagingApi.v2.Content));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearLocalizedPropertiesMap = function() {
  this.getLocalizedPropertiesMap().clear();
  return this;};


/**
 * map<string, string> localized_title = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getLocalizedTitleMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearLocalizedTitleMap = function() {
  this.getLocalizedTitleMap().clear();
  return this;};


/**
 * map<string, string> localized_subtitle = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getLocalizedSubtitleMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearLocalizedSubtitleMap = function() {
  this.getLocalizedSubtitleMap().clear();
  return this;};


/**
 * map<string, string> localized_content = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getLocalizedContentMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearLocalizedContentMap = function() {
  this.getLocalizedContentMap().clear();
  return this;};


/**
 * optional google.protobuf.StringValue deeplink = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getDeeplink = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
*/
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setDeeplink = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearDeeplink = function() {
  return this.setDeeplink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.hasDeeplink = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * map<string, string> deeplink_params = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getDeeplinkParamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearDeeplinkParamsMap = function() {
  this.getDeeplinkParamsMap().clear();
  return this;};


/**
 * optional google.protobuf.StringValue richmedia = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getRichmedia = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
*/
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setRichmedia = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearRichmedia = function() {
  return this.setRichmedia(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.hasRichmedia = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool system = 12;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getSystem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setSystem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string url = 13;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string inbox_image = 14;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getInboxImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setInboxImage = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string inbox_icon = 15;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getInboxIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setInboxIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional google.protobuf.Struct custom_data = 16;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getCustomData = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 16));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
*/
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setCustomData = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearCustomData = function() {
  return this.setCustomData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.hasCustomData = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * repeated string categories = 17;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional string banner = 18;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getBanner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setBanner = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string icon = 19;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetRequest.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.CreatePresetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    preset: (f = msg.getPreset()) && proto.pushwoosh.rpc_v2.presets.Preset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetResponse}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.CreatePresetResponse;
  return proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.CreatePresetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetResponse}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.presets.Preset;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.presets.Preset.deserializeBinaryFromReader);
      msg.setPreset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.CreatePresetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.presets.Preset.serializeBinaryToWriter
    );
  }
};


/**
 * optional Preset preset = 1;
 * @return {?proto.pushwoosh.rpc_v2.presets.Preset}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.prototype.getPreset = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.presets.Preset} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.presets.Preset, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.presets.Preset|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetResponse} returns this
*/
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.prototype.setPreset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.CreatePresetResponse} returns this
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.prototype.clearPreset = function() {
  return this.setPreset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.CreatePresetResponse.prototype.hasPreset = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sendType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    platformsMap: (f = msg.getPlatformsMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedPropertiesMap: (f = msg.getLocalizedPropertiesMap()) ? f.toObject(includeInstance, proto.pushwoosh.channels.messagingApi.v2.Content.toObject) : [],
    localizedTitleMap: (f = msg.getLocalizedTitleMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedSubtitleMap: (f = msg.getLocalizedSubtitleMap()) ? f.toObject(includeInstance, undefined) : [],
    localizedContentMap: (f = msg.getLocalizedContentMap()) ? f.toObject(includeInstance, undefined) : [],
    deeplink: (f = msg.getDeeplink()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    deeplinkParamsMap: (f = msg.getDeeplinkParamsMap()) ? f.toObject(includeInstance, undefined) : [],
    richmedia: (f = msg.getRichmedia()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    url: jspb.Message.getFieldWithDefault(msg, 13, ""),
    inboxImage: jspb.Message.getFieldWithDefault(msg, 14, ""),
    inboxIcon: jspb.Message.getFieldWithDefault(msg, 15, ""),
    customData: (f = msg.getCustomData()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    banner: jspb.Message.getFieldWithDefault(msg, 18, ""),
    icon: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest;
  return proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSendType(value);
      break;
    case 4:
      var value = msg.getPlatformsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readBool, null, 0, false);
         });
      break;
    case 5:
      var value = msg.getLocalizedPropertiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.channels.messagingApi.v2.Content.deserializeBinaryFromReader, "", new proto.pushwoosh.channels.messagingApi.v2.Content());
         });
      break;
    case 6:
      var value = msg.getLocalizedTitleMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = msg.getLocalizedSubtitleMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = msg.getLocalizedContentMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDeeplink(value);
      break;
    case 10:
      var value = msg.getDeeplinkParamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRichmedia(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setInboxImage(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setInboxIcon(value);
      break;
    case 16:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setCustomData(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setBanner(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSendType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatformsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeBool);
  }
  f = message.getLocalizedPropertiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.channels.messagingApi.v2.Content.serializeBinaryToWriter);
  }
  f = message.getLocalizedTitleMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLocalizedSubtitleMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLocalizedContentMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getDeeplink();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDeeplinkParamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRichmedia();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getInboxImage();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getInboxIcon();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCustomData();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = message.getBanner();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string send_type = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getSendType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setSendType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<uint32, bool> platforms = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,boolean>}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getPlatformsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,boolean>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearPlatformsMap = function() {
  this.getPlatformsMap().clear();
  return this;};


/**
 * map<string, pushwoosh.channels.messagingApi.v2.Content> localized_properties = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.pushwoosh.channels.messagingApi.v2.Content>}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getLocalizedPropertiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.pushwoosh.channels.messagingApi.v2.Content>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.pushwoosh.channels.messagingApi.v2.Content));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearLocalizedPropertiesMap = function() {
  this.getLocalizedPropertiesMap().clear();
  return this;};


/**
 * map<string, string> localized_title = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getLocalizedTitleMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearLocalizedTitleMap = function() {
  this.getLocalizedTitleMap().clear();
  return this;};


/**
 * map<string, string> localized_subtitle = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getLocalizedSubtitleMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearLocalizedSubtitleMap = function() {
  this.getLocalizedSubtitleMap().clear();
  return this;};


/**
 * map<string, string> localized_content = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getLocalizedContentMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearLocalizedContentMap = function() {
  this.getLocalizedContentMap().clear();
  return this;};


/**
 * optional google.protobuf.StringValue deeplink = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getDeeplink = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
*/
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setDeeplink = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearDeeplink = function() {
  return this.setDeeplink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.hasDeeplink = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * map<string, string> deeplink_params = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getDeeplinkParamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearDeeplinkParamsMap = function() {
  this.getDeeplinkParamsMap().clear();
  return this;};


/**
 * optional google.protobuf.StringValue richmedia = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getRichmedia = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
*/
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setRichmedia = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearRichmedia = function() {
  return this.setRichmedia(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.hasRichmedia = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string url = 13;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string inbox_image = 14;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getInboxImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setInboxImage = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string inbox_icon = 15;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getInboxIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setInboxIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional google.protobuf.Struct custom_data = 16;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getCustomData = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 16));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
*/
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setCustomData = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearCustomData = function() {
  return this.setCustomData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.hasCustomData = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * repeated string categories = 17;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional string banner = 18;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getBanner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setBanner = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string icon = 20;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetRequest.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    preset: (f = msg.getPreset()) && proto.pushwoosh.rpc_v2.presets.Preset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse;
  return proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.presets.Preset;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.presets.Preset.deserializeBinaryFromReader);
      msg.setPreset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.presets.Preset.serializeBinaryToWriter
    );
  }
};


/**
 * optional Preset preset = 1;
 * @return {?proto.pushwoosh.rpc_v2.presets.Preset}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.prototype.getPreset = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.presets.Preset} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.presets.Preset, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.presets.Preset|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse} returns this
*/
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.prototype.setPreset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse} returns this
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.prototype.clearPreset = function() {
  return this.setPreset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.presets.UpdatePresetResponse.prototype.hasPreset = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.DeletePresetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.DeletePresetRequest}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.DeletePresetRequest;
  return proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.DeletePresetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.DeletePresetRequest}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.DeletePresetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.presets.DeletePresetRequest} returns this
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.presets.DeletePresetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.presets.DeletePresetResponse}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.presets.DeletePresetResponse;
  return proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.presets.DeletePresetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.presets.DeletePresetResponse}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.presets.DeletePresetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.presets.DeletePresetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.presets);
